
export const SIGNER_ADD_REQUEST = "SignerAdd.Request";
export const SIGNER_ADD_SUCCESS = "SignerAdd.Success";
export const SIGNER_ADD_FAILURE = "SignerAdd.Failure";
export const SIGNER_ADD_RESET = "SignerAdd.Reset";

export function signerDocAdd(data: any, id: string) {
  return async (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: SIGNER_ADD_REQUEST });

    try {
      const response = await fetch(`/api/documents/${id}/signers`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result.status === "success") {
        dispatch({ type: SIGNER_ADD_SUCCESS, payload: result.result });
        return { success: true };
      } else {
        dispatch({ type: SIGNER_ADD_FAILURE, payload: result.result });
        return { payload: { message: result.result?.message ?? "Помилка" } }; 
      }
    } catch (error) {
      dispatch({ type: SIGNER_ADD_FAILURE, payload: { message: "Помилка з'єднання" } });
      return { payload: { message: "Помилка з'єднання з сервером" } };
    }
  };
}

export const SIGNER_DELETE_REQUEST = "SignerDelete.Request";
export const SIGNER_DELETE_SUCCESS = "SignerDelete.Success";
export const SIGNER_DELETE_FAILURE = "SignerDelete.Failure";
export const SIGNER_DELETE_RESET = "SignerDelete.Reset";

export function signerDocDelete(idDoc: string, id: string) {
  return async (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: SIGNER_DELETE_REQUEST });

    try {
      const response = await fetch(`/api/documents/${idDoc}/signers/${id}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status === "success") {
        dispatch({ type: SIGNER_DELETE_SUCCESS, payload: result.result });
        return { success: true };
      } else {
        dispatch({ type: SIGNER_DELETE_FAILURE, payload: result.result });
        return { payload: { message: result.result?.message ?? "Помилка" } }; 
      }
    } catch (error) {
      dispatch({ type: SIGNER_DELETE_FAILURE, payload: { message: "Помилка з'єднання" } });
      return { payload: { message: "Помилка з'єднання з сервером" } };
    }
  };
}